import { render, staticRenderFns } from "./ConsultationsMostUsedPieChart.vue?vue&type=template&id=2b2cae2e&scoped=true&"
import script from "./ConsultationsMostUsedPieChart.vue?vue&type=script&lang=js&"
export * from "./ConsultationsMostUsedPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2cae2e",
  null
  
)

export default component.exports